// import { Injectable } from '@angular/core';
// import * as S3 from 'aws-sdk/clients/s3';
// import { HttpClient, HttpResponse } from '@angular/common/http';
// import { environment } from '../../../environments/environment';
// import { TokenStorage } from '../../auth/token.storage';
// import { Router } from '@angular/router';
// import { ErrorExcelUpload } from '../../pages/schedulingandplanning/schedulingandplanning.component';
// import { MatDialog } from '@angular/material';
// import { BehaviorSubject, interval, Subscription } from 'rxjs';
// import { NotifierService } from 'angular-notifier';
// import { ExcelgeneratorService } from '../excelgenerator/excelgenerator.service';
// import { DatePipe } from '@angular/common';


// @Injectable({
//   providedIn: 'root'
// })

// export class UploadfileService {
//   subscription: Subscription;
//   private stopSpinner = new BehaviorSubject<any>(null);
//   event = this.stopSpinner.asObservable();

//   private notifyProgress = new BehaviorSubject<any>({ progressStatus: "" });
//   progressObservable = this.notifyProgress.asObservable();

//   month = new Date().getMonth() + 1;
//   folderName = "excel" + "/" + new Date().getDate() + "-" +
//     this.month + "-" + new Date().getFullYear() +
//     "T" + new Date().getHours() + ":" + new Date().getMinutes() +
//     ":" + new Date().getSeconds() + "_";
//   base_url: string;

//   constructor(public httpClient: HttpClient,
//     private token: TokenStorage,
//     private router: Router,
//     public dialog: MatDialog,
//     private notifier: NotifierService,
//     public excelService: ExcelgeneratorService,
//     public datePipe: DatePipe
//   ) {
//     this.base_url = environment.appUrl;
//   }

//   uploadExcelFile(excelFile) {
//     let paramsToAws;
//     console.log("In upload service", excelFile, this.token.getTenant());
//     const bucket = new S3(environment.S3Key);

//     paramsToAws = {
//       Bucket: this.token.getTenant(),
//       Key: this.folderName + excelFile.name,
//       Body: excelFile
//     };

//     let bucketUploadPromise = bucket.upload(paramsToAws).promise();
//     bucketUploadPromise.then(data => {
//       console.log('Success', data);
//       this.httpClient.get(this.base_url + '/orders/excel-report?filePath='.concat(this.folderName).concat(excelFile.name), { observe: 'response' }).subscribe(response => {
//         let obj = JSON.stringify(response.body);
//         console.log('Response', response);
//         if (response.status == 202) {
//           const timer = interval(10000);
//           this.subscription = timer.subscribe(val => this.getUploadOrderStatusApiCall(JSON.parse(obj).hashId));
//         }
//       }, error => {
//         console.log("Error", error);
//         this.stopSpinner.next(null);
//         this.notifier.notify('error', "Error uploading excel, Plase try again.");

//       });
//     }).catch(err => {
//       this.stopSpinner.next(null);
//       this.notifier.notify('error', "Error uploading excel, Plase try again.");
//       console.log(err);
//     });
//   }
//   uploadOrderExcelFile_WithoutS3(excelFile) {
//     debugger; 

//     console.log("Uploading file directly to Web API", excelFile, this.token.getTenant());

//     let excelData = new FormData();
//     excelData.append('file', excelFile);

//     this.httpClient.post(environment.appUrl + '/orders/excel-report-without-s3?filePath='.concat(this.folderName).concat(excelFile.name),
//       excelData, { observe: 'response' })
//       .subscribe(response => {
//         let obj = JSON.stringify(response.body);
//         console.log('Response:', response);
//         if (response.status == 202) {
//           const timer = interval(10000);
//           this.subscription = timer.subscribe(val => this.getUploadOrderStatusApiCall(JSON.parse(obj).hashId));
//         }
//       }, error => {
//         console.log("Error", error);
//         this.stopSpinner.next(null);
//         this.notifier.notify('error', "Error uploading excel, Please try again.");
//       });
//   }

//   getUploadOrderStatusApiCall(hashId) {
//     debugger; 
//     this.httpClient.get(environment.appUrl + '/orders/excel-report/progress/' + hashId, { observe: 'response' }).subscribe((res: any) => {
//       console.log("response", res);
//       if (res.status == 200) {
//         this.stopSpinner.next(null);
//         this.subscription.unsubscribe();
//         console.log(res.body);
//         if (res.body.Result == 'blank')
//           this.notifier.notify('error', "Error: Attempt to upload blank excel.");
//         else if (res.body.Result == 'only header')
//           this.notifier.notify('error', "Error: Attempt to upload excel with no data and only headers.");
//         else {
//           if (!res.body.Result && !res.body.ErrorSummary) {
//             this.notifier.notify('success', "Excel Uploaded Successfully");
//             this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
//               this.router.navigate(["/scheduling"]));
//           }
//           else if (res.body.Result || res.body.ErrorSummary) {
//             this.notifier.notify('success', "Excel Uploaded Successfully");
//             const showResult = this.dialog.open(ErrorExcelUpload, {
//               width: 'fit-content',
//               maxWidth: 'fit-content',
//               maxHeight: '76vh',
//               position: { top: '8%' },
//               data: res.body
//             });

//             showResult.afterClosed().subscribe(result => {
//               debugger;
//               if (result) {
//                 this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
//                   this.router.navigate(["/scheduling"]));
//               }
//             });
//           }
//         }
//       } else {
//         this.notifyProgress.next(res.body);
//       }
//     }, error => {
//       this.stopSpinner.next(null);
//       this.subscription.unsubscribe();
//       this.notifier.notify('error', "Error uploading excel, Please try again.");
//       console.log(error);
//     });
//   }

//   searchInvoices(excelFile) {
//     let paramsToAws;
//     console.log("In upload service", excelFile, this.token.getTenant());
//     const bucket = new S3(environment.S3Key);

//     paramsToAws = {
//       Bucket: this.token.getTenant(),
//       Key: this.folderName + excelFile.name,
//       Body: excelFile
//     };

//     let bucketUploadPromise = bucket.upload(paramsToAws).promise();
//     bucketUploadPromise.then(data => {
//       console.log('Success', data);
//       this.httpClient.get(this.base_url + '/reports/orderReportByInvoices?filePath='.concat(this.folderName).concat(excelFile.name), { observe: 'response' }).subscribe(response => {
//         console.log('Response', response);
//         this.exportAsXLSX(response.body)
//         this.stopSpinner.next(null);
//       }, error => {
//         console.log("Error", error);
//         this.stopSpinner.next(null);
//         if (error.error.Result) {
//           this.notifier.notify('error', error.error.Result);
//         }
//         else {
//           this.notifier.notify('error', 'Error uploading excel, Plase try again.');
//         }

//       });
//     }).catch(err => {
//       this.stopSpinner.next(null);
//       this.notifier.notify('error', "Error uploading excel, Plase try again.");
//       console.log(err);
//     });
//   }

//   exportAsXLSX(orders) {
//     console.log(orders)
//     let excelRecords = [];
//     if (orders.length > 0) {
//       orders.forEach(order => {
//         let createdOn, delivereddate, orderstatus, driver, vehicle, comments, dispatchDate, feedbackRating;
//         if (order) {

//           if (order.created_on)
//             createdOn = this.datePipe.transform(order.created_on, "mediumDate");
//           else
//             createdOn = '-----'

//           if (order.delivered_on)
//             delivereddate = this.datePipe.transform(order.delivered_on, "medium");
//           else
//             delivereddate = '-----'

//           if (order.dispatchDate)
//             dispatchDate = this.datePipe.transform(order.dispatchDate, "mediumDate");
//           else
//             dispatchDate = '-----'

//           if (order.driver)
//             driver = order.driver;
//           else
//             driver = '-----'

//           if (order.vehicle)
//             vehicle = ', ' + order.vehicle;
//           else
//             vehicle = ''

//           if (order.feedbackComments)
//             comments = ', ' + order.feedbackComments;
//           else
//             comments = ''

//           if (order.feedback_rating)
//             feedbackRating = order.feedback_rating;
//           else
//             feedbackRating = ''

//           orderstatus = order.orderstatus.slice(12);
//         }
//         excelRecords.push({
//           'Order': order.invoice_number || '',
//           'Billing From': order.originated_from,
//           'Delivery From': order.dispatched_from,
//           'Created On': createdOn,
//           'Dispatched On': dispatchDate,
//           'Status': orderstatus = order ? order.orderstatus.slice(12) : '',
//           'Reason': order.failedReason || '',
//           'Customer': order.receiver_name || '',
//           'Driver': driver || '',
//           'Vehicle': vehicle || '',
//           'Delivered On': delivereddate,
//           'Product Name': order.productName || '',
//           'Product Category': order.productCategory || '',
//           'Serial No.': order.serial_numbers || '',
//           'Customer rating': feedbackRating,
//           'Comments': comments || '',
//           'POD Available': order ? order.pod_image_exists : '',
//         })
//       });
//     }
//     this.excelService.exportAsExcelFile(excelRecords, 'searchinvoices');
//   }
//   async uploadImageAzureBlobStorage(image: File, jobId: number) {

//     debugger;
//     console.log("Uploading file directly to Web API", image, this.token.getTenant());
    
//     try{
//       let imageData = new FormData();
//       imageData.append('file', image);

//       let imageName: string = new Date().getDate() + "-" +
//         this.month + "-" + new Date().getFullYear() +
//         "T" + new Date().getHours() + ":" + new Date().getMinutes() +
//         ":" + new Date().getSeconds() + "_" + image.name;

//       let filePath = 'images/' + jobId + '/transporter/web/' + imageName;

//       let response = await this.httpClient.post(environment.appUrl + '/azureblob/uploadFile?filePath='.concat(filePath), imageData, { observe: 'response' }).toPromise();
//       if (response.status == 200) {
//         this.httpClient.put(environment.appUrl + '/pod/job/?jobId=' + jobId + '&web=' + true, null).toPromise().then(async (status) => {
//           this.stopSpinner.next(null);
//           this.notifier.notify('success', "Upload successful.");
//           console.log(status);
//           if (Object.values(status)[0] != "JOB_STATE_DELIVERED") {
//             await this.httpClient.put(environment.appUrl + '/jobs/' + jobId + '/updatedeliverystatus?web=' + true, null).toPromise().then(() => {
//               this.notifier.notify('success', "Job Delivered Successfully.");
//             }, Error => {
//               this.stopSpinner.next(null);
//               this.notifier.notify('error', "Failed to update job delivery status.");
//             })
//           }
//         }, Error => {
//           this.stopSpinner.next(null);
//         })
//       }
//     }
//     catch (error) {
//       console.error("Upload failed", error);
//       this.notifier.notify('error', "Error uploading POD, Please try again.");
//     } finally {
//         this.stopSpinner.next(null); // Always stop the spinner
//     }
//   }
// }
import { Injectable } from '@angular/core';
import * as S3 from 'aws-sdk/clients/s3';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { TokenStorage } from '../../auth/token.storage';
import { Router } from '@angular/router';
import { ErrorExcelUpload } from '../../pages/schedulingandplanning/schedulingandplanning.component';
import { MatDialog } from '@angular/material';
import { BehaviorSubject, interval, Subscription } from 'rxjs';
import { NotifierService } from 'angular-notifier';
import { ExcelgeneratorService } from '../excelgenerator/excelgenerator.service';
import { DatePipe } from '@angular/common';


@Injectable({
  providedIn: 'root'
})

export class UploadfileService {
  subscription: Subscription;
  private stopSpinner = new BehaviorSubject<any>(null);
  event = this.stopSpinner.asObservable();

  private notifyProgress = new BehaviorSubject<any>({ progressStatus: "" });
  progressObservable = this.notifyProgress.asObservable();

  month = new Date().getMonth() + 1;
  folderName = "excel" + "/" + new Date().getDate() + "-" +
    this.month + "-" + new Date().getFullYear() +
    "T" + new Date().getHours() + ":" + new Date().getMinutes() +
    ":" + new Date().getSeconds() + "_";
  base_url: string;
   

  constructor(public httpClient: HttpClient,
    private token: TokenStorage,
    private router: Router,
    public dialog: MatDialog,
    private notifier: NotifierService,
    public excelService: ExcelgeneratorService,
    public datePipe: DatePipe
  ) {
    this.base_url = environment.appUrl;
  }

  async uploadExcelFile(excelFile) {
    // let paramsToAws;
    // console.log("In upload service", excelFile, this.token.getTenant());
    // const bucket = new S3(environment.S3Key);

    // paramsToAws = {
    //   Bucket: this.token.getTenant(),
    //   Key: this.folderName + excelFile.name,
    //   Body: excelFile
    // };

    // let bucketUploadPromise = bucket.upload(paramsToAws).promise();
    // bucketUploadPromise.then(data => {
    //   console.log('Success', data);
    //   this.httpClient.get(this.base_url + '/orders/excel-report?filePath='.concat(this.folderName).concat(excelFile.name), { observe: 'response' }).subscribe(response => {
    //     let obj = JSON.stringify(response.body);
    //     console.log('Response', response);
    //     if (response.status == 202) {
    //       const timer = interval(10000);
    //       this.subscription = timer.subscribe(val => this.getUploadOrderStatusApiCall(JSON.parse(obj).hashId));
    //     }
    //   }, error => {
    //     console.log("Error", error);
    //     this.stopSpinner.next(null);
    //     this.notifier.notify('error', "Error uploading excel, Plase try again.");

    //   });
    // }).catch(err => {
    //   this.stopSpinner.next(null);
    //   this.notifier.notify('error', "Error uploading excel, Plase try again.");
    //   console.log(err);
    // });
  }
  uploadOrderExcelFile_WithoutS3(excelFile) {
    let excelData = new FormData();
    excelData.append('file', excelFile);
  
    const url = `${environment.appUrl}/orders/excel-report-without-s3?filePath=${this.folderName}${excelFile.name}`;
  
    this.httpClient.post(url, excelData, { observe: 'response' }).subscribe(response => {
      if (response.status === 202) {
        let responseData = JSON.parse(JSON.stringify(response.body));
  
        // Stop previous polling if it exists
        if (this.subscription) {
          this.subscription.unsubscribe();
        }
  
        // Start polling every 10 seconds
        const timer = interval(10000);
        this.subscription = timer.subscribe(() => this.getUploadOrderStatusApiCall(responseData.hashId));
      }
    }, error => {
      console.error("Error uploading Excel:", error);
      this.stopSpinner.next(null);
      this.notifier.notify('error', "Error uploading excel, Please try again.");
    });
  }
  
  getUploadOrderStatusApiCall(hashId) {
    this.httpClient.get(`${environment.appUrl}/orders/excel-report/progress/${hashId}`, { observe: 'response' })
      .subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            this.stopSpinner.next(null);
            
            // Stop polling when upload is successful
            if (this.subscription) {
              this.subscription.unsubscribe();
            }
  
            if (res.body.Result === 'blank') {
              this.notifier.notify('error', "Error: Attempt to upload blank Excel.");
            } 
            else if (res.body.Result === 'only header') {
              this.notifier.notify('error', "Error: Attempt to upload Excel with no data and only headers.");
            } 
            else {
              this.notifier.notify('success', "Excel Uploaded Successfully");
              this.router.navigate(["/scheduling"], { replaceUrl: true });
            }
          } else {
            this.notifyProgress.next(res.body);
          }
        },
        error: error => {
          this.stopSpinner.next(null);
  
          // Stop polling on error
          if (this.subscription) {
            this.subscription.unsubscribe();
          }
  
          console.error("Upload Status API Error:", error);
          this.notifier.notify('error', "Error uploading Excel, Please try again.");
        }
      });
  }
    
  searchInvoices(excelFile: File) {
    debugger;
    let excelData = new FormData();
    excelData.append('file', excelFile);
  
    // Check the URL
    console.log("URL being hit: ", `${environment.appUrl}/reports/orderReportByInvoices?filePath=${this.folderName}${excelFile.name}`);
    
    this.httpClient.post(`${environment.appUrl}/reports/orderReportByInvoices?filePath=${this.folderName}${excelFile.name}`, excelData, { observe: 'response' }).subscribe(
      (response) => {
          
        if (response.status === 200) {
          let responseData = response.body;
          console.log("Upload Successful:", responseData);
          this.notifier.notify('success', 'Report generated successfully!');
        } else if (response.status === 204) {
          this.notifier.notify('warning', "No data found for the provided invoices.");
          console.log("No data found.");
        }
      },
      (error) => {
         
        this.stopSpinner.next(null);
        console.error("Upload Error:", error);
  
        // Handle specific error cases based on status code
        if (error.status === 400) {
          this.notifier.notify('error', `Error: ${error.error.Result}`);
        } else if (error.status === 500) {
          this.notifier.notify('error', "Internal server error. Please try again later.");
        } else if (error.status === 404) {
          this.notifier.notify('error', "Endpoint not found. Please check your request.");
        } else if (error.status === 422) {
          this.notifier.notify('error', `Validation error: ${error.error.Result}`);
        } else {
          this.notifier.notify('error', "Error uploading Excel, please try again.");
        }
      }
    );
  }
  
  

  
    // paramsToAws = {
    //   Bucket: this.token.getTenant(),
    //   Key: this.folderName + excelFile.name,
    //   Body: excelFile
    // };

    // let bucketUploadPromise = bucket.upload(paramsToAws).promise();
    // bucketUploadPromise.then(data => {
    //   console.log('Success', data);
    //   this.httpClient.get(this.base_url + '/reports/orderReportByInvoices?filePath='.concat(this.folderName).concat(excelFile.name), { observe: 'response' }).subscribe(response => {
    //     console.log('Response', response);
    //     this.exportAsXLSX(response.body)
    //     this.stopSpinner.next(null);
    //   }, error => {
    //     console.log("Error", error);
    //     this.stopSpinner.next(null);
    //     if (error.error.Result) {
    //       this.notifier.notify('error', error.error.Result);
    //     }
    //     else {
    //       this.notifier.notify('error', 'Error uploading excel, Plase try again.');
    //     }

    //   });
   

  exportAsXLSX(orders) {
    console.log(orders)
    let excelRecords = [];
    if (orders.length > 0) {
      orders.forEach(order => {
        let createdOn, delivereddate, orderstatus, driver, vehicle, comments, dispatchDate, feedbackRating;
        if (order) {

          if (order.created_on)
            createdOn = this.datePipe.transform(order.created_on, "mediumDate");
          else
            createdOn = '-----'

          if (order.delivered_on)
            delivereddate = this.datePipe.transform(order.delivered_on, "medium");
          else
            delivereddate = '-----'

          if (order.dispatchDate)
            dispatchDate = this.datePipe.transform(order.dispatchDate, "mediumDate");
          else
            dispatchDate = '-----'

          if (order.driver)
            driver = order.driver;
          else
            driver = '-----'

          if (order.vehicle)
            vehicle = ', ' + order.vehicle;
          else
            vehicle = ''

          if (order.feedbackComments)
            comments = ', ' + order.feedbackComments;
          else
            comments = ''

          if (order.feedback_rating)
            feedbackRating = order.feedback_rating;
          else
            feedbackRating = ''

          orderstatus = order.orderstatus.slice(12);
        }
        excelRecords.push({
          'Order': order.invoice_number || '',
          'Billing From': order.originated_from,
          'Delivery From': order.dispatched_from,
          'Created On': createdOn,
          'Dispatched On': dispatchDate,
          'Status': orderstatus = order ? order.orderstatus.slice(12) : '',
          'Reason': order.failedReason || '',
          'Customer': order.receiver_name || '',
          'Driver': driver || '',
          'Vehicle': vehicle || '',
          'Delivered On': delivereddate,
          'Product Name': order.productName || '',
          'Product Category': order.productCategory || '',
          'Serial No.': order.serial_numbers || '',
          'Customer rating': feedbackRating,
          'Comments': comments || '',
          'POD Available': order ? order.pod_image_exists : '',
        })
      });
    }
    this.excelService.exportAsExcelFile(excelRecords, 'searchinvoices');
  }
  async uploadImageAzureBlobStorage(image: File, jobId: number) {

    debugger;
    console.log("Uploading file directly to Web API", image, this.token.getTenant());
    
    try{
      let imageData = new FormData();
      imageData.append('file', image);

      let imageName: string = new Date().getDate() + "-" +
        this.month + "-" + new Date().getFullYear() +
        "T" + new Date().getHours() + ":" + new Date().getMinutes() +
        ":" + new Date().getSeconds() + "_" + image.name;

      let filePath = 'images/' + jobId + '/transporter/web/' + imageName;

      let response = await this.httpClient.post(environment.appUrl + '/azureblob/uploadFile?filePath='.concat(filePath), imageData, { observe: 'response' }).toPromise();
      if (response.status == 200) {
        this.httpClient.put(environment.appUrl + '/pod/job/?jobId=' + jobId + '&web=' + true, null).toPromise().then(async (status) => {
          this.stopSpinner.next(null);
          this.notifier.notify('success', "Upload successful.");
          console.log(status);
          if (Object.values(status)[0] != "JOB_STATE_DELIVERED") {
            await this.httpClient.put(environment.appUrl + '/jobs/' + jobId + '/updatedeliverystatus?web=' + true, null).toPromise().then(() => {
              this.notifier.notify('success', "Job Delivered Successfully.");
            }, Error => {
              this.stopSpinner.next(null);
              this.notifier.notify('error', "Failed to update job delivery status.");
            })
          }
        }, Error => {
          this.stopSpinner.next(null);
        })
      }
    }
    catch (error) {
      console.error("Upload failed", error);
      this.notifier.notify('error', "Error uploading POD, Please try again.");
    } finally {
        this.stopSpinner.next(null); // Always stop the spinner
    }
  }
}